import { FC } from 'react'
import styles from 'components/features/coaching/advisorPublicPage/AdvisorCertificate/AdvisorCertificate.styl'
import { CertificateType, certificates } from 'components/features/coaching/advisor/constants'
import SvgIcon from 'components/atoms/SvgIcon'
import WinnerSvg from 'icons/winner.svg?skip-svgo'

type AdvisorCertificateProps = {
  certificate: CertificateType
}
export const AdvisorCertificate: FC<AdvisorCertificateProps> = (props) => {
  const { certificate } = props
  const certInfo = certificates[certificate]

  if (!certInfo) {
    return null
  }

  return (
    <AdvisorCertificateInner
      abbr={ certificate }
      title={ certInfo.title }
      description={ certInfo.description }
    />
  )
}

type AdvisorCertificateInnerProps = {
  abbr: string
  title: string
  description: string
}
const AdvisorCertificateInner: FC<AdvisorCertificateInnerProps> = (props) => {
  const { abbr, title, description } = props

  return (
    <div className={ styles.advisorCertificate }>
      <div className={ styles.left }>
        <div className={ styles.image }>
          <SvgIcon src={ WinnerSvg } />
        </div>
        <div className={ styles.abbr }>{ abbr }</div>
      </div>
      <div className={ styles.right }>
        <div className={ styles.title }>{ title }</div>
        <div className={ styles.description }>{ description }</div>
      </div>
    </div>
  )
}
